// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popopslide-heading {
  float: left;
  padding: 6px 0;
  font-size: 20px;
  text-align: left;
  color: #495058;
}

.popopslide-heading h5 {
  margin-bottom: 0;
}

.h5, h5 {
  font-size: 1.25rem;
}

.popopslide-inner {
  width: 90%;
  height: 100%;
  padding: 0 15px;
  background: #fff;
  position: absolute;
  right: 0;
  top: 0;
  border: 1px solid #ccc;
}`, "",{"version":3,"sources":["webpack://./src/app/analytics/analytic-builder/add-analytics-builder/add-analytics-builder.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,UAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,sBAAA;AACJ","sourcesContent":[".popopslide-heading {\r\n    float: left;\r\n    padding: 6px 0;\r\n    font-size: 20px;\r\n    text-align: left;\r\n    color: #495058;\r\n}\r\n\r\n.popopslide-heading h5 {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.h5, h5 {\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.popopslide-inner {\r\n    width: 90%;\r\n    height: 100%;\r\n    padding: 0 15px;\r\n    background: #fff;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 0;\r\n    border: 1px solid #ccc;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
